import React from "react";
import { Button, Tooltip, Typography } from "antd"

import { ExportOutlined } from "@ant-design/icons";

import { json2csv, Json2CsvOptions } from "json-2-csv"
import * as FileSaver  from "file-saver"

export const ExportarComoCSV: React.FC<{ getData: () => Promise<object[]>, options?: Json2CsvOptions, nomeDoArquivo?: string, loading?: boolean }> = (props) => {
    return (
        <React.Fragment>
            <Tooltip title={<>Exportar como CSV</>}>
                <Button
                    loading={props.loading}
                    onClick={async () => {
                        const data = await props.getData();
                        const csv = json2csv(data, props.options);
                        FileSaver.saveAs(new Blob([csv]), props.nomeDoArquivo ?? "data.csv");
                    }}
                    icon={<ExportOutlined />}
                >
                    CSV
                </Button>
            </Tooltip>
        </React.Fragment>
    );

}

export default ExportarComoCSV;
